<template>
	<card class="tw-flex tw-justify-between">
		<div class="tw--mt-4">
			<span class="text-info text-sm tw-text-left relative" style="bottom: -12px" >{{ selectedFactor.name }}</span>
			<factor-progress-bar
				:length="selectedFactor.weighWith.length"
				:completed-items-count="comparePivotIndex + 1"
				complete-position="right"
				class="tw-w-96"
			/>
		</div>
		<v-btn
			v-if="hasNextFactor"
			class="custom-button"
			color="primary"
			:disabled="!factorWeighingIsCompleted"
			@click="$emit('nextFactorClick')"
		>
			Siguiente Factor
		</v-btn>
	</card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import WeighingFactorProgressBar
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/WeighingFactorProgressBar';
import FactorProgressBar
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/FactorProgressBar';

export default {
	name: 'WeighingFactorStatus',
	components: { FactorProgressBar, WeighingFactorProgressBar, Card },
	props: ['selectedFactor', 'selectedFactors', 'hasNextFactor', 'combinations', 'factorWeighingIsCompleted', 'comparePivotIndex'],
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorStatus.vue